import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/harapan-jaya.png'
import _imports_1 from '@/assets/img/modal-confirmation/roster-confirmation.svg'
import _imports_2 from '@/assets/img/ticket-route.png'


const _hoisted_1 = {
  key: 0,
  class: "xl:relative w-100 h-100 py-10 min-h-screen"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10 pl-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-10",
    alt: "logo"
  })
], -1)
const _hoisted_3 = {
  class: "flex items-center",
  style: {"min-height":"250px"}
}
const _hoisted_4 = {
  key: 0,
  class: "mx-auto"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg text-center font-semibold px-2 lg:text-xl lg:px-0" }, " Tiket tidak ditemukan. Silahkan tunggu beberapa saat lagi atau hubungi Admin kami ", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "lg:grid grid-cols-2 gap-4"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-extrabold text-3xl mb-1" }, "Bus Harapan Jaya", -1)
const _hoisted_10 = { class: "text-center font-semibold text-2xl mb-5" }
const _hoisted_11 = {
  class: "background-grey-lighten-5 rounded-lg mx-auto mb-5 p-4",
  style: {"width":"320px","height":"320px"}
}
const _hoisted_12 = { class: "block lg:hidden" }
const _hoisted_13 = { class: "py-5 px-3 md:px-10" }
const _hoisted_14 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-sm" }, "Naik dari Kota", -1)
const _hoisted_16 = { class: "text-center font-extrabold text-3xl" }
const _hoisted_17 = { class: "text-center font-semibold text-sm" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-sm" }, "Tujuan", -1)
const _hoisted_20 = { class: "text-center font-extrabold text-3xl" }
const _hoisted_21 = { class: "text-center font-semibold text-sm" }
const _hoisted_22 = { class: "py-5 border-top-grey-2" }
const _hoisted_23 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Tanggal Cetak:", -1)
const _hoisted_25 = { class: "text-center font-extrabold text-xl" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Jam Cetak:", -1)
const _hoisted_27 = { class: "text-center font-extrabold text-xl" }
const _hoisted_28 = { class: "py-5 border-top-grey-2 border-bottom-grey-2 mb-5" }
const _hoisted_29 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Nopol", -1)
const _hoisted_31 = { class: "text-center font-extrabold text-xl" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Kategori", -1)
const _hoisted_33 = { class: "text-center font-extrabold text-xl" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Jenis", -1)
const _hoisted_35 = { class: "text-center font-extrabold text-xl" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Jenis Bus", -1)
const _hoisted_37 = { class: "text-center font-extrabold text-xl" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Track", -1)
const _hoisted_39 = { class: "text-center font-extrabold text-xl" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Total", -1)
const _hoisted_41 = { class: "text-center font-extrabold text-xl" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-base text-grey text-center font-normal mb-5 px-5 xl:px-20 lg:mb-0" }, " Tiket ini berlaku untuk tanggal yang tertera di atas. Tiket ini tidak dapat dipindahtangankan. Jagalah tiket anda dengan baik untuk verifikasi. ", -1)
const _hoisted_43 = {
  class: "m-auto rounded-xl p-2 hidden lg:block",
  style: {"width":"430px","box-shadow":"0px 0px 8px rgba(0, 0, 0, 0.25)"}
}
const _hoisted_44 = { class: "py-5" }
const _hoisted_45 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-sm" }, "Naik dari Kota", -1)
const _hoisted_47 = { class: "text-center font-extrabold text-3xl" }
const _hoisted_48 = { class: "text-center font-semibold text-sm" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-sm" }, "Tujuan", -1)
const _hoisted_51 = { class: "text-center font-extrabold text-3xl" }
const _hoisted_52 = { class: "text-center font-semibold text-sm" }
const _hoisted_53 = { class: "py-5 border-top-grey-2" }
const _hoisted_54 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Tanggal Cetak:", -1)
const _hoisted_56 = { class: "text-center font-extrabold text-xl" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Jam Cetak:", -1)
const _hoisted_58 = { class: "text-center font-extrabold text-xl" }
const _hoisted_59 = { class: "py-5 border-top-grey-2" }
const _hoisted_60 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Nopol", -1)
const _hoisted_62 = { class: "text-center font-extrabold text-xl" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Kategori", -1)
const _hoisted_64 = { class: "text-center font-extrabold text-xl" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Jenis", -1)
const _hoisted_66 = { class: "text-center font-extrabold text-xl" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Jenis Bus", -1)
const _hoisted_68 = { class: "text-center font-extrabold text-xl" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Track", -1)
const _hoisted_70 = { class: "text-center font-extrabold text-xl" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-base" }, "Total", -1)
const _hoisted_72 = { class: "text-center font-extrabold text-xl" }
const _hoisted_73 = {
  key: 0,
  class: "lg:w-3/4 m-auto lg:mt-10"
}
const _hoisted_74 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QrCode = _resolveComponent("QrCode")!
  const _component_Card = _resolveComponent("Card")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Card, { class: "lg:w-3/4 m-auto" }, {
            content: _withCtx(() => [
              (!_ctx.dataSource)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, _toDisplayString(`No : ${_ctx.dataSource?.Code ?? '-'}`), 1),
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.Qrvalue)
                          ? (_openBlock(), _createBlock(_component_QrCode, {
                              key: 0,
                              value: _ctx.Qrvalue,
                              size: _ctx.Qrsize,
                              level: "H"
                            }, null, 8, ["value", "size"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", null, [
                              _hoisted_15,
                              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.dataSource?.OriginTerminalCode ?? '-'), 1),
                              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.dataSource?.Origin ?? '-'), 1)
                            ]),
                            _hoisted_18,
                            _createElementVNode("div", null, [
                              _hoisted_19,
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.dataSource?.DestinationTerminalCode ?? '-'), 1),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.dataSource?.Destination ?? '-'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", null, [
                              _hoisted_24,
                              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.date), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_26,
                              _createElementVNode("div", _hoisted_27, _toDisplayString(`${_ctx.time} WIB`), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", null, [
                              _hoisted_30,
                              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.dataSource?.VehicleRegNumber ?? '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_32,
                              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.dataSource?.MsPassengerName ?? '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_34,
                              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.dataSource?.PaymentType ?? '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_36,
                              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.dataSource?.TrayekClassName ?? '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_38,
                              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.dataSource?.IsTol ? 'TOL' : 'NON-TOL'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_40,
                              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.currencyNumberFormat(_ctx.dataSource?.Price ?? 0)), 1)
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_42
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", null, [
                            _hoisted_46,
                            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.dataSource?.OriginTerminalCode ?? '-'), 1),
                            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.dataSource?.Origin ?? '-'), 1)
                          ]),
                          _hoisted_49,
                          _createElementVNode("div", null, [
                            _hoisted_50,
                            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.dataSource?.DestinationTerminalCode ?? '-'), 1),
                            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.dataSource?.Destination ?? '-'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", null, [
                            _hoisted_55,
                            _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.date), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_57,
                            _createElementVNode("div", _hoisted_58, _toDisplayString(`${_ctx.time} WIB`), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", null, [
                            _hoisted_61,
                            _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.dataSource?.VehicleRegNumber ?? '-'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_63,
                            _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.dataSource?.MsPassengerName ?? '-'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_65,
                            _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.dataSource?.PaymentType ?? '-'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_67,
                            _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.dataSource?.TrayekClassName ?? '-'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_69,
                            _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.dataSource?.IsTol ? 'TOL' : 'NON-TOL'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_71,
                            _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.currencyNumberFormat(_ctx.dataSource?.Price ?? 0)), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _: 1
          })
        ]),
        (_ctx.dataSource)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
              _createElementVNode("div", {
                innerHTML: _ctx.ticketDescription,
                class: "px-11",
                style: {"white-space":"pre-line"}
              }, null, 8, _hoisted_74)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}